import React from 'react'
import { ResponsiveContainer, BarChart, CartesianGrid, YAxis, Tooltip, XAxis, Bar } from 'recharts'

const BarDashboardChart = ({
	containerProps,
	barChartProps,
	xAxisProps,
	yAxisProps,
	tooltipProps,
	barProps,
	color
}) => {
	return (
		<ResponsiveContainer {...containerProps}>
			<BarChart {...barChartProps}>
				<defs>
					<linearGradient id={`bar-gradient${color}`} x1='0' y1='0' x2='0' y2='1'>
						<stop offset='56%' stopColor={color} stopOpacity={0.35} />
						<stop offset='100%' stopColor={color} stopOpacity={0} />
					</linearGradient>
				</defs>
				<CartesianGrid strokeDasharray='3 3' vertical={false} />
				<XAxis {...xAxisProps} />
				<YAxis {...yAxisProps} />
				<Tooltip {...tooltipProps} />
				<Bar {...barProps} fill={`url(#bar-gradient${color})`} />
			</BarChart>
		</ResponsiveContainer>
	)
}

export default BarDashboardChart
